import { Indikator } from '../data/indikator.model';
import { IndikatorTyp } from './enums/indikator-typ';

// WARNUNG!!! WENN JEMAND EINEN DER INDIKATOREN (indikator) HIER UMBENENNT FUNKTIONIERT DER WEBSERVICE NICHT! WENN ES NOTWENDIG WIRD DANN INFORMIER DEN WEBSERVICE ENTWICKLER!!!

export const indikatorenAuswahlDaten: Indikator[] = [
  {
    idIndikator: -1,
    indikator: 'Abschnitt',
    subIndikatoren: [
      {
        idIndikator: -1,
        indikator: 'Haltung',
        checked: false,
        subIndikatoren: null,
        indikatorTyp: null,
        indeterminate: null,
        tooltip: null
      },
      {
        idIndikator: -2,
        indikator: 'Transport',
        checked: false,
        subIndikatoren: null,
        indikatorTyp: null,
        indeterminate: null,
        tooltip: null
      },
      {
        idIndikator: -3,
        indikator: 'Schlachtung',
        checked: false,
        subIndikatoren: null,
        indikatorTyp: null,
        indeterminate: null,
        tooltip: null
      },
    ],
    indikatorTyp: IndikatorTyp.LEBENSABSCHNITT,
    checked: false,
    indeterminate: false,
    tooltip: 'Abschnitt, zu dem der Indikator eine Aussage trifft. Ein Indikator kann auf mehrere Abschnitte zutreffen'
  },
  {
    idIndikator: -2,
    indikator: 'Tierwohl-Dimension',
    subIndikatoren: [
      {
        idIndikator: -1,
        indikator: 'Gesundheit',
        checked: false,
        subIndikatoren: null,
        indikatorTyp: null,
        indeterminate: null,
        tooltip: null
      },
      {
        idIndikator: -2,
        indikator: 'Verhalten',
        checked: false,
        subIndikatoren: null,
        indikatorTyp: null,
        indeterminate: null,
        tooltip: null
      },
      {
        idIndikator: -3,
        indikator: 'Emotionen',
        checked: false,
        subIndikatoren: null,
        indikatorTyp: null,
        indeterminate: null,
        tooltip: null
      },
    ],
    indikatorTyp: IndikatorTyp.DIMENSION_DES_TIERWOHLS,
    checked: false,
    indeterminate: false,
    tooltip: 'Dimension des Tierwohls, zu der der Indikator vorwiegend eine Aussage trifft. Ein Indikator kann auf mehrere Dimensionen zutreffen.'
  },
  {
    idIndikator: -3,
    indikator: 'Bezug',
    subIndikatoren: [
      {
        idIndikator: -1,
        indikator: 'tierbezogen',
        checked: false,
        subIndikatoren: null,
        indikatorTyp: null,
        indeterminate: null,
        tooltip: null
      },
      {
        idIndikator: -2,
        indikator: 'ressourcen-/managementbezogen',
        checked: false,
        subIndikatoren: null,
        indikatorTyp: null,
        indeterminate: null,
        tooltip: null
      },
    ],
    indikatorTyp: IndikatorTyp.INDIKATORENART,
    checked: false,
    indeterminate: false,
    tooltip: null
  },
  {
    idIndikator: -4,
    indikator: 'Tierwohl-Begleitindikatoren',
    subIndikatoren: [
      {
        idIndikator: -1,
        indikator: 'Rechtliche Rahmenbedingungen',
        checked: false,
        subIndikatoren: null,
        indikatorTyp: null,
        indeterminate: null,
        tooltip: null
      },
      {
        idIndikator: -2,
        indikator: 'Förderung',
        checked: false,
        subIndikatoren: null,
        indikatorTyp: null,
        indeterminate: null,
        tooltip: null
      },
      {
        idIndikator: -3,
        indikator: 'Konsum',
        checked: false,
        subIndikatoren: null,
        indikatorTyp: null,
        indeterminate: null,
        tooltip: null
      },
      {
        idIndikator: -4,
        indikator: 'Produktion',
        checked: false,
        subIndikatoren: null,
        indikatorTyp: null,
        indeterminate: null,
        tooltip: null,
      },
    ],
    indikatorTyp: IndikatorTyp.BEGLEIT_INDIKATOR,
    checked: false,
    indeterminate: false,
    tooltip: null
  },
];
